/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputField } from '@jutro/legacy/components';
import { Icon, DateField } from '@jutro/components';
import { Link } from '@jutro/router';
import { useTranslator } from '@jutro/locale';
import { accessibilityAddTableRow, focusNextElement, screenReaderAnnounce } from 'premier-capability-hooks';

import styles from './AtFaultaccidentsComponent.module.scss';
import metadata from './AtFaultaccidentsComponent.metadata.json5';
import messages from './AtFaultaccidentsComponent.messages';

function AtFaultaccidentsComponent(props) {

    const {
        data: AtFaultaccidentsVM,
        updateWizardData,
        submissionVM,
        AtFaultaccidentsPath,
        id: AtFaultaccidentsId
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();

    const addAtFaultaccidents = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            AtFaultaccidentsVM.value = AtFaultaccidentsVM.value || []

            const { _xCenter, _dtoName } = AtFaultaccidentsVM;

            const AtFaultaccidentsObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            AtFaultaccidentsObjVM.isValidationReq.value = true;
            AtFaultaccidentsObjVM.numFie.value = AtFaultaccidentsVM.value.length + 1
            AtFaultaccidentsVM.pushElement(
                AtFaultaccidentsObjVM
            );
            updateWizardData(submissionVM);
            
            accessibilityAddTableRow('Fault Accidents');
            setTimeout(() => {
                focusNextElement(true,0, `${AtFaultaccidentsId }numFie`);
            }, 3000);
        },
        [submissionVM, updateWizardData, AtFaultaccidentsVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            const removedAccident = AtFaultaccidentsVM.value[index];

            AtFaultaccidentsVM.value.splice(index, 1);
            _.set(submissionVM.value, AtFaultaccidentsPath, AtFaultaccidentsVM.value);
            updateWizardData(submissionVM);
            screenReaderAnnounce(translator(messages.removeAccident, {accDesc: removedAccident.desFie}))
            focusNextElement(true,0, `addAtFaultaccidentsButtonId`); 
        }, [submissionVM, updateWizardData, AtFaultaccidentsPath, AtFaultaccidentsVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'numFie') {
                const value = item.numFie ? item.numFie : '';

                return (
                    <InputField
                        id={index + AtFaultaccidentsId+ path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.numFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'datofAccFie') {
                const value = item.datofAccFie ? item.datofAccFie : '';

                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType='object'
                        path={path}
                        format="short"
                        layout="full-width"
                        showOptional={false}
                        onValueChange={(val, changedPath) => {
                            item.datofAccFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }

            if (path === 'desFie') {
                const value = item.desFie ? item.desFie : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.desFie = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [handleValueChange])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem, translator]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`AtFaultaccidentsTable`]: {
            data: AtFaultaccidentsVM.value,
        },
        [`addAtFaultaccidentsButtonId`]: {
            'aria-label':  "Add At Fault Accident"
        }

    }), [AtFaultaccidentsVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addAtFaultaccidents,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            AtFaultaccidentsVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [AtFaultaccidentsVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={AtFaultaccidentsVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

AtFaultaccidentsComponent.propTypes = wizardProps;
export default withRouter(AtFaultaccidentsComponent);
